import React, { createContext, useContext, useEffect, useState } from 'react';
import { offerConfig } from '../data/siteConfig';
import { formatARS } from '../utils/currency';
type OfferContextValue = {
  secondsLeft: number;
  expired: boolean;
  price: number;
  priceLabel: string;
  nextPriceLabel: string;
};
const STORAGE_KEY = 'v360_offer_deadline';
const DURATION_MS = offerConfig.reservationMinutes * 60 * 1000;
const OfferContext = createContext<OfferContextValue | null>(null);
export function OfferProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [deadline] = useState(readDeadline);
  const [now, setNow] = useState(() => Date.now());
  const remainingMs = Math.max(0, deadline - now);
  const expired = remainingMs === 0;
  useEffect(() => {
    if (expired) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [expired]);
  const price = expired ? offerConfig.nextPrice : offerConfig.launchPrice;
  const value: OfferContextValue = {
    secondsLeft: Math.ceil(remainingMs / 1000),
    expired,
    price,
    priceLabel: formatARS(price),
    nextPriceLabel: formatARS(offerConfig.nextPrice)
  };
  return <OfferContext.Provider value={value} data-id="element-325" data-mp="1es0wwf0xke78">{children}</OfferContext.Provider>;
}
export function useOffer(): OfferContextValue {
  const ctx = useContext(OfferContext);
  if (!ctx) throw new Error('useOffer debe usarse dentro de OfferProvider');
  return ctx;
}

// Un vencimiento por visitante, guardado para que no se reinicie al recargar.
function readDeadline(): number {
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(stored) && stored > 0) return stored;
    const deadline = Date.now() + DURATION_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return Date.now() + DURATION_MS;
  }
}